import fetchApi from "../../../lib/fetchApi";
import { PaginationFilterDto } from "../../../types/Pagination";
import store from "../../../redux/store";
import { SurveyImportCreateDto, SurveyImportDetailDto, SurveyImportDto, SurveyImportPagination } from "../types";
import { ApiErrorResponse } from "../../../types/ApiErrorResponse";

const BASE_URL = "/surveyImport";

export const getSurveyImports = async (body: PaginationFilterDto): Promise<SurveyImportPagination> => {
    try {
        return await fetchApi.post(`${BASE_URL}`, body);
    } catch (error) {
        const fetchError = error as ApiErrorResponse;
        throw fetchError;
    }
};

export const getProccessAI = async (surveyImportId: number) => {
    const response = await fetchApi.get(`${BASE_URL}/${surveyImportId}/processAI`);
    return response;
};

export const getSurveyProccessAI = async (surveyImportResultId: number) => {
    const response = await fetchApi.get(`${BASE_URL}/survey/${surveyImportResultId}/processAI`);
    return response;
};


export const deleteSurveyImport = async (surveyImportId: number, reasonDelete: string) => {
    const response = await fetchApi.delete(`${BASE_URL}/${surveyImportId}`, {
        params: {
            reasonDelete
        }
    });
    return response;
};

export const getSurveyImportDetails = async (surveyImportId: string, body: PaginationFilterDto) => {
    try {
        const response = await fetchApi.put(`${BASE_URL}/${surveyImportId}/details`, body) as SurveyImportDetailDto;
        return response;
    } catch (error) {
        const fetchError = error as ApiErrorResponse;
        throw fetchError;
    }

};

export const surveyImportUpload = async (
    body: SurveyImportCreateDto
): Promise<SurveyImportDto> => {
    const formData = new FormData();
    formData.append('Description', body.description);
    formData.append('File', body.file);
    formData.append('TemplateId', body.templateId.toString());

    const response = await fetchApi.post(`${BASE_URL}/upload`, formData) as SurveyImportDto;

    return response;
}

export const processAISurveys = async (surveyImportId: string) => {
    const state = store.getState();

    const selectedFilters =
        state.filters.detailSurveyLoads.selectedFilters;

     await fetchApi.put(`${BASE_URL}/${surveyImportId}/processAI`, selectedFilters) ;
}